import React from 'react';
import {useTranslation} from 'react-i18next';
import {ImageFitEnum, ImageFittable} from '../../../../incase-domain/common/imageFit';
import Label from '../../../../incase-domain/components/label/Label';
import DropdownMenuCompact from '../../../../incase-domain/components/dropdownMenuCompact/DropdownMenuCompact';
import Button from '../../../../incase-domain/components/button/Button';

interface ImageFitProps {
    highlightedElement: ImageFittable;
    highlightedElementChangeHandler: {single: (field: keyof ImageFittable, value: ImageFitEnum) => void};
}
export function ImageFit(props: ImageFitProps): JSX.Element {
    const {highlightedElement, highlightedElementChangeHandler} = props;

    const {t} = useTranslation();

    const OPTIONS = [
        {label: t(`imageFit.${ImageFitEnum.CONTAIN}`), value: ImageFitEnum.CONTAIN},
        {label: t(`imageFit.${ImageFitEnum.COVER}`), value: ImageFitEnum.COVER},
    ];

    return (
        <div className="l-group--form">
            <div className="l-group__item ">
                <Label>{t('imageFit.title')}</Label>
                <DropdownMenuCompact
                    width="full"
                    className="c-sidepanel__dropdown"
                    items={[
                        [
                            {
                                label: t(`imageFit.${ImageFitEnum.CONTAIN}`),
                                onClick: () => highlightedElementChangeHandler.single('imageFit', ImageFitEnum.CONTAIN),
                            },
                            {
                                label: t(`imageFit.${ImageFitEnum.COVER}`),
                                onClick: () => highlightedElementChangeHandler.single('imageFit', ImageFitEnum.COVER),
                            },
                        ],
                    ]}
                >
                    <Button
                        variant="soft"
                        size="xs"
                        fullWidth
                        trailing="solar:alt-arrow-down-linear"
                        className="c-sidepanel__dropdown_button"
                    >
                        {OPTIONS.find((val) => val.value === highlightedElement.imageFit)?.label ||
                            t('presEditPage.editSidebar.elements.selectPlaceholder')}
                    </Button>
                </DropdownMenuCompact>
            </div>
        </div>
    );
}
